import React from 'react';
import PropTypes from 'prop-types';

import {Box, Stack, TextCharLimit, Grid, SwitchCheckbox, Button} from 'views/components';
import {translate, Translate} from 'views/module';

const ContentNew = (props) => {
  const careviewItem = props.careviewItem;
  const setCareviewItem = props.setCareviewItem;

  const questionTitle = careviewItem.questionData.questionTitle;
  const questionOptions = careviewItem.questionData.options;

  const setQuestionTitle = (value) => {
    setCareviewItem((e) => {
      return {
        ...e,
        questionTitle: value,
      };
    });
  };
  const updateOptionTitle = (index, optionTitle) => {
    setCareviewItem((e) => {
      const newOptions = [...e.options];
      newOptions[index] = {...newOptions[index], optionTitle};

      return {
        ...e,
        options: newOptions,
      };
    });
  };
  const updateOptionFollowup = (index, followUp) => {
    setCareviewItem((e) => {
      const newOptions = [...e.options];
      newOptions[index] = {...newOptions[index], followUp};

      return {
        ...e,
        options: newOptions,
      };
    });
  };
  const addNewOption = () => {
    setCareviewItem((e) => {
      const newOptions = [...e.options];
      newOptions.push({});

      return {
        ...e,
        options: newOptions,
      };
    });
  };

  return (
    <Box>
      <Stack
        spacing={1}
      >
        <TextCharLimit
          label={translate('client.ClientDetail.CareviewSettings.Types.YesNo.Question')}
          placeholder={translate('client.ClientDetail.CareviewSettings.Types.YesNo.Question')}
          value={questionTitle}
          onChange={setQuestionTitle}
          charLimit={180}
          autoFocus
          fullWidth
        />
        {
          questionOptions.map((option, index) => {
            return (
              <Grid
                key={index}
                container
              >
                <Grid item xs={8}>
                  <TextCharLimit
                    label={translate('client.ClientDetail.CareviewSettings.Types.MultipleChoice.OptionNumber', {number: index + 1})}
                    placeholder={translate('client.ClientDetail.CareviewSettings.Types.MultipleChoice.OptionNumber', {number: index + 1})}
                    value={option.optionTitle}
                    onChange={(e) => updateOptionTitle(index, e)}
                    charLimit={180}
                    autoFocus
                    fullWidth
                  />
                </Grid>
                <Grid item xs={4}>
                  <SwitchCheckbox
                    label={translate('client.ClientDetail.CareviewSettings.Types.YesNo.Followup')}
                    value={option.followUp || false}
                    onChange={(e) => updateOptionFollowup(index, e)}
                  />
                </Grid>
              </Grid>
            );
          })
        }
        <Box>
          <Button
            onClick={addNewOption}
            fullWidth={false}
          >
            <Translate expression='client.ClientDetail.CareviewSettings.Types.MultipleChoice.AddNew' />
          </Button>
        </Box>
      </Stack>
    </Box>
  );
};

ContentNew.propTypes = {
  careviewItem: PropTypes.object.isRequired,
  setCareviewItem: PropTypes.func.isRequired,
};
export default React.memo(ContentNew);
